import React from 'react';
import { LTTooltip } from '@lambdatestincprivate/lt-components';
import WarningIcon from '../../assets/WarningIcon';

const triggerStyles = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-start',
  gap: '8px',
  maxWidth: '200px',
  width: 'fit-content',
  overflow: 'hidden',
  padding: '4px 8px',
  borderRadius: '4px',
  cursor: 'pointer',
  background: 'transparent',
  border: 'none',
  fontSize: '14px',
  fontWeight: 500,
  lineHeight: '18px',
  color: 'inherit',
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis'
};

const textStyles = {
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  lineHeight: '18px'
};

const RCACompactTrigger = ({ rcaCategory, icon, onClick, aiCapabilityEnabled = true }) => {
  if (!rcaCategory && !aiCapabilityEnabled) return null;
  const buttonText = rcaCategory || 'Generate RCA';

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      onClick?.(e);
    }
  };

  return (
    <LTTooltip text={buttonText}>
      <div
        role="button"
        tabIndex={0}
        aria-label={buttonText}
        style={triggerStyles}
        className="hye-rca-compact-trigger"
        onClick={onClick}
        onKeyDown={handleKeyDown}
      >
        {icon || <WarningIcon />}
        <span style={textStyles}>{buttonText}</span>
      </div>
    </LTTooltip>
  );
};

export default RCACompactTrigger;
